import React from 'react';
import styled from 'styled-components';
import CloseButton from '../CloseButton';
import XIcon from '../icons/XIcon';
import { Divider, FooterNote, Modal, Title } from '../Modal';
import { bookingStrings, str } from './strings';

const dryRunStrings = bookingStrings.confirmation.dryRun;

interface BookingConfirmationDryRunProps {
    closeConfirmation: () => void;
}

const BookingConfirmationDryRun = ({
    closeConfirmation,
}: BookingConfirmationDryRunProps) => (
    <Modal disableBodyScroll data-auto='booking-confirmation-screen'>
        <CloseButton onClick={closeConfirmation} />
        <Header>
            <ErrorIcon>
                <XIcon />
            </ErrorIcon>
            <Title>{str(dryRunStrings.title)}</Title>
        </Header>
        <Divider />
        <FooterNote>{str(dryRunStrings.note)}</FooterNote>
    </Modal>
);

const Header = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
`;

const ErrorIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 58px;
    height: 58px;
    border-radius: 50%;
    background-color: #fae3e4;
    margin: 0 auto 16px auto;

    svg {
        width: 32px;
        height: 32px;
        stroke: #bc3834;
        stroke-width: 2;
        stroke-linecap: round;
        fill: none;
    }
`;

export default BookingConfirmationDryRun;
